module.exports = __webpack_public_path__ + "static/Foto3-91eeee03c3c61afcb2a111972b2a16c7.png";